/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivitiesBoardDialogController', ActivitiesBoardDialogController);

    ActivitiesBoardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ActivitiesBoard', 'MemberManagement', '$http'];

    function ActivitiesBoardDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ActivitiesBoard, MemberManagement, $http) {
        var vm = this;

        vm.activities = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        $scope.removeBooking = false;
        vm.getUser = getUser;

        if($stateParams.user) {
            MemberManagement.get({id : $stateParams.user}, function(result) {
                vm.activities.profile = result;
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.activities.id !== null) {
                ActivitiesBoard.update(vm.activities, onSaveSuccess, onSaveError);
            } else {
                ActivitiesBoard.save(vm.activities, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:activitiesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.activitiesDate = false;
        vm.datePickerOpenStatus.validFrom = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getUser(val) {
            return $http.get('api/_search/profiles/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }
    }
})();
